module.exports = __webpack_public_path__ + "static/media/network_purple.749b7c6e.svg";